// Blog article (.tp-gpost) — sidebar behaviour: TOC (auto-open on desktop,
// active-section highlight on scroll) + sticky sign-up form (same fields and
// AJAX handler as /sign-up/: contact_form_submit, inc/Ajax.php).
document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.tp-gpost');
    if (!root) {
        return;
    }

    // ── TOC ──────────────────────────────────────────────────────────────
    var toc = root.querySelector('.js-toc');
    if (toc) {
        // Десктоп: всегда раскрыт (details сворачивается только на мобильном).
        var mq = window.matchMedia('(min-width: 861px)');
        function syncOpen() {
            if (mq.matches) {
                toc.setAttribute('open', '');
            }
        }
        syncOpen();
        if (mq.addEventListener) {
            mq.addEventListener('change', syncOpen);
        }

        // Клик по пункту: свой скролл в capture-фазе — глобальный smooth-
        // обработчик default-page.js (scrollIntoView) здесь не срабатывает.
        toc.addEventListener('click', function (e) {
            var a = e.target.closest ? e.target.closest('.js-toc-link') : null;
            if (!a) return;
            var id = decodeURIComponent(a.getAttribute('href')).slice(1);
            var target = document.getElementById(id);
            if (!target) return;
            e.preventDefault();
            e.stopPropagation();
            var top = target.getBoundingClientRect().top + window.pageYOffset - 110;
            window.scrollTo({ top: top, behavior: 'smooth' });
            if (history.replaceState) {
                history.replaceState(null, '', '#' + id);
            }
        }, true);

        // Подсветка активного раздела.
        var links = Array.prototype.slice.call(toc.querySelectorAll('.js-toc-link'));
        var byId = {};
        links.forEach(function (a) {
            byId[decodeURIComponent(a.getAttribute('href')).slice(1)] = a;
        });
        var headings = Object.keys(byId)
            .map(function (id) { return document.getElementById(id); })
            .filter(Boolean);

        if (headings.length) {
            var current = null;
            function activate(id) {
                if (current === id) return;
                current = id;
                links.forEach(function (a) { a.classList.remove('is-active'); });
                if (id && byId[id]) byId[id].classList.add('is-active');
            }
            // Активен последний заголовок, прошедший линию 130px от верха.
            var ticking = false;
            function update() {
                ticking = false;
                var id = null;
                for (var i = 0; i < headings.length; i++) {
                    if (headings[i].getBoundingClientRect().top <= 130) {
                        id = headings[i].id;
                    } else {
                        break;
                    }
                }
                activate(id);
            }
            window.addEventListener('scroll', function () {
                if (!ticking) {
                    ticking = true;
                    requestAnimationFrame(update);
                }
            }, { passive: true });
            update();
        }
    }

    // ── Форма в сайдбаре ─────────────────────────────────────────────────
    var form = root.querySelector('.tp-gpost__form .cs-form');
    if (!form) {
        return;
    }

    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var PHONE_RE = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;

    function formatPhone(val) {
        var digits = val.replace(/\D/g, '');
        if (digits.length > 0 && digits[0] === '1') {
            digits = digits.slice(1);
        }
        digits = digits.slice(0, 10);
        if (!digits) {
            return '';
        }
        var r = '+1 (' + digits.slice(0, 3);
        if (digits.length > 3) { r += ') ' + digits.slice(3, 6); }
        if (digits.length > 6) { r += '-' + digits.slice(6, 10); }
        return r;
    }

    var first = form.querySelector('[name="first_name"]');
    var last = form.querySelector('[name="last_name"]');
    var email = form.querySelector('[name="email"]');
    var phone = form.querySelector('[name="phone"]');
    var info = form.querySelector('[name="info"]');
    var errEl = form.querySelector('.cs-error');
    var submit = form.querySelector('.cs-form__submit');

    function showErr(msg) {
        if (errEl) {
            errEl.textContent = msg;
            errEl.style.display = 'block';
        }
    }
    function clearErr() {
        if (errEl) {
            errEl.textContent = '';
            errEl.style.display = 'none';
        }
    }

    function showCaptcha(captcha) {
        var field = form.querySelector('.js-captcha');
        if (!field) {
            field = document.createElement('label');
            field.className = 'cs-field js-captcha';
            field.innerHTML = '<span class="cs-label js-captcha-q"></span>' +
                '<input class="cs-input" type="text" name="captcha_answer" inputmode="numeric" autocomplete="off" placeholder="Answer"/>' +
                '<input type="hidden" name="captcha_token"/>';
            var anchor = errEl || submit;
            anchor.parentNode.insertBefore(field, anchor);
        }
        field.querySelector('.js-captcha-q').textContent = 'Quick check: ' + captcha.question + ' = ?';
        field.querySelector('[name="captcha_token"]').value = captcha.token;
        var ans = field.querySelector('[name="captcha_answer"]');
        ans.value = '';
        ans.focus();
    }

    [first, last, email, phone, info].forEach(function (el) {
        if (el) {
            el.addEventListener('input', clearErr);
        }
    });

    // Green highlight once a field holds a valid value.
    function markValid(el) {
        if (!el) { return; }
        var v = (el.value || '').trim();
        var ok;
        if (el.type === 'email') { ok = EMAIL_RE.test(v); }
        else if (el.name === 'phone') { ok = v !== '' && PHONE_RE.test(v); }
        else { ok = v !== ''; }
        el.classList.toggle('is-valid', ok);
    }
    form.querySelectorAll('.cs-input, .cs-textarea').forEach(function (el) {
        el.addEventListener('input', function () { markValid(el); });
        el.addEventListener('blur', function () { markValid(el); });
    });

    if (phone) {
        phone.addEventListener('input', function () {
            var pos = phone.selectionStart;
            var oldLen = phone.value.length;
            phone.value = formatPhone(phone.value);
            var delta = phone.value.length - oldLen;
            phone.setSelectionRange(pos + delta, pos + delta);
        });
    }

    if (submit) {
        submit.addEventListener('click', function (e) {
            e.preventDefault();
            if (!first || !first.value.trim()) {
                showErr('Please enter your first name.');
                return;
            }
            if (!email || !EMAIL_RE.test(email.value.trim())) {
                showErr('Please enter a valid email address.');
                return;
            }
            if (!phone || !PHONE_RE.test(phone.value.trim())) {
                showErr('Please enter a valid phone number so we can reach you.');
                return;
            }
            clearErr();
            submit.disabled = true;

            var honeypot = form.querySelector('[name="company_website"]');
            var params = new URLSearchParams();
            params.set('action', 'contact_form_submit');
            params.set('contact_nonce', (window.appVars && window.appVars.nonce) || '');
            params.set('first_name', first.value.trim());
            params.set('last_name', last ? last.value.trim() : '');
            params.set('email', email.value.trim());
            params.set('phone', phone.value.trim());
            params.set('goal', info ? info.value.trim() : '');
            params.set('company_website', honeypot ? honeypot.value : '');
            params.set('page_url', window.location.href);

            var capToken = form.querySelector('[name="captcha_token"]');
            var capAnswer = form.querySelector('[name="captcha_answer"]');
            if (capToken && capToken.value) {
                params.set('captcha_token', capToken.value);
                params.set('captcha_answer', capAnswer ? capAnswer.value.trim() : '');
            }

            // Таймаут: если запрос завис, кнопка не должна остаться disabled.
            var ctrl = new AbortController();
            var timer = setTimeout(function () { ctrl.abort(); }, 15000);

            fetch((window.appVars && window.appVars.ajaxurl) || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: params,
                signal: ctrl.signal
            })
                .then(function (r) { return r.json(); })
                .then(function (data) {
                    if (data && data.success) {
                        window.location.href = (window.appVars && window.appVars.thankYouUrl) || '/thank-you/';
                    } else {
                        submit.disabled = false;
                        if (data && data.data && data.data.captcha) {
                            showCaptcha(data.data.captcha);
                        }
                        showErr((data && data.data && data.data.message) || 'Something went wrong. Please try again.');
                    }
                })
                .catch(function () {
                    submit.disabled = false;
                    showErr('Something went wrong. Please try again.');
                })
                .finally(function () {
                    clearTimeout(timer);
                });
        });
    }
});
